/**
 * External dependencies
 */
import React, { useState } from "react";
import { Box, Stack } from "@towersystems/towersystems-design-system";
import { map } from "lodash";
import classnames from "classnames";
import PopoverMenu from "components/popover/menu";
import Icon from "components/icon";
import { ButtonV2 } from "components/button-v2";
import { Text } from "components/text";
import "./styles.scss";

const DropdownLink = ({
  disabled,
  label,
  title,
  onOuterAction,
  onClose,
  items,
  showArrow = true,
  className,
  buttonRender,
  children,
  icon,
  labelStyle = { fontSize: 12 },
  labelClassNames,
}) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const handleClick = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const classes = classnames(
    "dropdown-link__wrapper",
    { "is-open": isMenuVisible, "has-arrow": showArrow, disabled },
    className,
  );

  const handleClose = () => {
    setIsMenuVisible(false);
    onClose && onClose();
  };

  return (
    <Box className={classes}>
      <PopoverMenu
        className={classnames("dropdown-link", className)}
        enterExitTransitionDurationMs={50}
        onOuterAction={() =>
          onOuterAction ? onOuterAction(handleClose) : handleClose()
        }
        isOpen={isMenuVisible}
        showArrow={showArrow}
        content={
          <Stack className="dropdown-link__content p-3">
            {map(items, (item) => {
              let c = classnames("dropdown-link__item", {
                active: item.isActive,
              });
              return (
                <Box key={item.key} className="dropdown-link__item-wrapper">
                  <ButtonV2
                    active={item.active}
                    className={c}
                    disabled={disabled || item.disabled}
                    onClick={async () => {
                      setIsMenuVisible(false);
                      await new Promise((r) => setTimeout(r, 100)); // stop the render from blinking

                      item.onClick(item);
                    }}
                  >
                    <Text>{item.label}</Text>
                  </ButtonV2>
                </Box>
              );
            })}
            {children && children({ close: handleClose })}
          </Stack>
        }
      >
        {(buttonRender && buttonRender({ handleClick, title, label })) || (
          <Box
            component="button"
            onClick={handleClick}
            alignItems="center"
            justifyContent="spaceBetween"
            display="flex"
            className={classnames("dropdown-link__title", labelClassNames)}
            style={{ ...labelStyle }}
          >
            {icon && <Icon {...icon} />}
            {title || label || "-"}
            {showArrow && <div className="dropdown-link__down-arrow"></div>}
          </Box>
        )}
      </PopoverMenu>
    </Box>
  );
};

export default DropdownLink;
